export default "__VITE_ASSET__DJSs6nhB__"